export const STICKY_PAGE_ACTIONS_EVENTS = {
    REGISTER_ACTION: 'sticky-page-actions-register-action',
    REMOVE_ACTION: 'sticky-page-actions-remove-action',
    UPDATE_BADGE_COUNT: 'sticky-page-actions-update-badge-count',
    TOGGLE_VISIBLE: 'sticky-page-actions-toggle-visible',
    UPDATE_BOTTOM_OFFSET: 'sticky-page-actions-update-bottom-offset',
};
